var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tc box"},[_c('p',[_vm._v("扫描二维码关注松溪县博物馆微信公众号")]),_c('p',[_vm._v("进行票务预约")]),_c('img',{attrs:{"src":require("@/assets/imgs/visited.png")}})])
}]

export { render, staticRenderFns }